<du-config-detail [navigateBack]="{commands: (appName && queryID) ? [ConfigRouteEnum.QUERY, appName, queryID] : [ConfigRouteEnum.QUERY]}">
    <detail-header>
        @if (logoUrl && logoUrl.length > 0) {
            <img
                    [ngSrc]="logoUrl"
                    alt="{{title}} logo"
                    width="64" height="64" priority>
        }
        <div>
            <h1 class="detail-header-title">
                {{ appName }}
            </h1>
            @if (queryID) {
                <p class="detail-header-subtitle">
                    {{ "#" + queryID }}
                </p>
            }
        </div>
    </detail-header>
    <detail-body>
        <p-card class="query-edit-card">
                <form class="form-container" #queryForm="ngForm">
                    <div class="field">
                        <label>{{ 'query.queryName' | translate }}</label>
                        <input pInputText required [(ngModel)]="queryName" name="queryName">
                    </div>
                    <div class="field">
                        <label>{{ 'query.queryVersion' | translate }}</label>
                        <input pInputText required placeholder="1.0.0" [(ngModel)]="queryVersion" name="queryVersion">
                    </div>
                    <div class="field">
                        <label>{{ 'query.appName' | translate }}</label>
                        <input pInputText required [(ngModel)]="appName" name="appName">
                    </div>
                    <div class="field">
                        <label>{{ 'query.appVersion' | translate }}</label>
                        <input pInputText required placeholder="1.0.0" [(ngModel)]="appVersion" name="appVersion">
                    </div>
                    <div class="field">
                        <label>{{ 'query.dialect' | translate }}</label>
                        <input pInputText required [(ngModel)]="dialect" name="dialect">
                    </div>
                </form>
                <div class="editor-container">
                    <div class="editor-header">
                        <i class="pi pi-code"></i>
                        <span>{{ queryName }}</span>
                        <span>v{{ queryVersion }}</span>
                    </div>
                    <div class="editor">
                        <ngx-monaco-editor [options]="editorOptions"
                                           [(ngModel)]="code"></ngx-monaco-editor>
                    </div>
                </div>
                <div class="editor-actions">
                    <p-button severity="secondary" (click)="validateQuery()">
                        @if (aiLoading) {
                            <i class="pi pi-spin pi-spinner"></i>
                        } @else {
                            <i class="pi pi-verified"></i>
                        }
                        {{ 'button.validate' | translate | uppercase }}
                    </p-button>
                    <p-button severity="secondary" (click)="resetQuery()">
                        <i class="pi pi-refresh"></i>
                        {{ 'button.reset' | translate | uppercase }}
                    </p-button>
                    <p-button (click)="saveQuery()" [disabled]="queryForm.invalid">
                        <i class="pi pi-save"></i>
                        {{ 'button.save' | translate | uppercase }}
                    </p-button>
                </div>

                @if (aiActive && !aiLoading) {
                    <div class="response-container">
                        <p-card>
                                <strong>{{ 'query.aiResponse' | translate }}</strong>
                                <span><b>{{ 'query.aiValid' | translate }}:</b> {{ aiValid }}</span>
                                <span>{{ aiNotes }}</span>
                        </p-card>
                    </div>
                    <div class="warning-container">
                        @if (aiWarning) {
                            <p-card class="warning-card">
                                    <strong style="color: orange">{{ 'query.aiWarning' | translate }}</strong>
                                    <span><b>{{ 'query.aiType' | translate }}:</b> {{ aiWarningType }}</span>
                                    <span>{{ aiWarningMessage }}</span>
                            </p-card>
                        }
                        @if (aiError) {
                            <p-card class="warning-card">
                                    <strong style="color: red">{{ 'query.aiError' | translate }}</strong>
                                    <span><b>{{ 'query.aiFragment' | translate }}
                                        :</b> {{ aiErrorCodeFragment }}</span>
                                    <span>{{ aiErrorMessage }}</span>
                            </p-card>
                        }
                    </div>
                } @else if (aiLoading) {
                    <div class="loading-container">
                        <p-progressSpinner [style]="{width: '60px', height: '60px'}"/>
                    </div>
                }
        </p-card>
    </detail-body>
</du-config-detail>
